export const STATUS_MESSAGES = {
	ERROR: "Error",
	SUCCESS: "Success",
	WARNING: "Warning",
};

export const SYSTEM_MESSAGES = {
	LIVE_ENDED: "Live stream ended!",
	DATA_NOT_FOUND: "Not Found Data!",
	USER_WAS_BLOCKED: "User was blocked!",
	STREAM_NOT_EXIST: "This stream not exist!",
	CONTACT_ADMIN: "Please contact admin for more detail!",
	NUMBER_REGISTERED: "The number has been registered!",
	USER_UPDATE_PROFILE_SUCCESS: "User updated profile successfully!",
	DELETE_PHOTO_PROFILE_SUCCESS: "Delete photo profile successfully!",
	DELETE_STREAM_SUCCESS: "Delete stream successfully!",
	RECORDED_STREAM_SUCCESS: "Recorded stream successfully!",
	INVALID_DATE: "Invalid Date!",
	MAX_LENGTH_CHAT: "140文字以内に入力してください。",
	BANNED_WORD: "使用できない単語が含まれています。",
    URL_SHARED_MESSAGE: "URLをコピーしました"
};
